<template>
<div id="SlideManage">
    <div v-if="SlideManageShow" class="well" style="padding: 0 1em">
      <div style="text-align: left; padding: 0.5rem 2rem">

        目前活動花絮共 {{ total }}筆<br />

      </div>
    <b-tabs content-class="mt-3" justified>
      <div
        class="dataTables_scrollBody"
        style="
          font-size: 14px;
          position: relative;
          overflow: auto;
          max-height: 100%;

          border-bottom: 1px solid #111;
          border-top: 1px solid #111;
        "
      >
        <b-table-simple
          class="ncut-table-menu-striped ncut-table-menu"
           fixed
          responsive
          bgcolor="#FFFFFF"
        >
          <b-thead class="ncut-thead-menu">
            <b-tr>
              <b-th style="min-width: 2em">序號</b-th>
              <b-th style="min-width: 26em">相簿名稱</b-th>
              <b-th style="min-width: 5em">拍攝時間</b-th>
              <b-th style="min-width: 2em">檢視相片</b-th>

            </b-tr>
          </b-thead>
          <b-tbody class="ncut-tbody-menu">
            <b-tr
              v-for="(item, index) in filteredDocs"
              :key="item.sid"
              :index="item.sid"
              :name="item.sid"
              v-bind:style="{
                background: selectedRowIndex == index ? headerColor : '',
              }"
              @click="selectedRowIndex = index"
            >
              <b-td style="text-align: right">
                {{ (currentPage - 1) * pageSize + index + 1 }}
              </b-td>
              <b-td style="text-align: left">
                {{ item.title }}
              </b-td>
                <b-td style="text-align: left">
                {{ getToday(item.updateTime) }}
              </b-td>
              <b-td style="text-align: left">
              <a href="#"  @click="GetSlide(item.sid,item.title,item.count)" > {{ item.count }} 張相片</a>
              </b-td>

            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="pageSize"
          v-if="total > pageSize"
        />
      </div>
    </b-tabs>
  <b-modal size="xl" ref="GetSlide" hide-footer>
        <template #modal-title> 檢視照片 </template>
        <GetSlide
         :sid="sid"
         :title="title"
         :count2="count2"
        @hideModal="hideModal('GetSlide')">
        </GetSlide>
      </b-modal>
    </div>
  </div>
</template>

</template>

<script>
import GetSlide from '@/components/GetSlide2.vue'

import * as tools from '../tool'
export default {
  name: 'SlideManage',
  data () {
    return {

      index: null,
      courseName: null,
      SlideManageShow: false,
      sid: null,
      title: null,
      count2: 0,
      signUpID: null,
      today: null,
      signUpStatus: null,
      selected: null,
      editId: 0,
      over: 0,
      total: 0,
      total2: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10
    }
  },
  components: {
    GetSlide
  },
  methods: {
    hideModal (name) {
      this.$refs[name].hide()
      this.getAllSlide()
    },
    getToday (updateTime) {
      var dd = new Date(updateTime)
      var today = dd.getDate().toString().padStart(2, '0') // 內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
      var yyyy = dd.getFullYear()
      return (tools.stringFormat('{0}-{1}-{2}', yyyy, mm, today))
    },

    getAllSlide () {
      const vm = this
      this.$http
        .get('./WebApi/ociaRep/GetAllSlide/')
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data

            vm.total = vm.inputData.length
            vm.currentPage = 1
            vm.currentPage2 = 1
          }
        })
        .catch(function (error) {
          alert('網路連線失敗' + error)
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        })
    },
    GetSlide (sid, title, count) {
      var vm = this
      vm.count2 = count
      this.sid = sid
      this.title = title

      vm.$refs.GetSlide.show()
    }

  },
  computed: {
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },

    headerColor () {
      return '#f7e8aa'
    }
  },
  created () {
    console.log('======created SlideManageView =====')
    this.isIE =
      navigator.userAgent.indexOf('MSIE ') > -1 ||
      navigator.userAgent.indexOf('Trident/') > -1 ||
      navigator.userAgent.indexOf('Edge') > -1
    const vm = this

    vm.SlideManageShow = true

    vm.getAllSlide()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
